package one.devsbox.www.ui.login

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import kotlinx.coroutines.launch
import one.devsbox.commons.ads.ApiAds
import one.devsbox.www.io.Repository
import one.devsbox.www.io.Repository.ads
import tk.mallumo.compose.navigation.navTo_HomeUI
import tk.mallumo.compose.navigation.viewmodel.NavigationViewModel
import tk.mallumo.compose.navigation.viewmodel.VM


@VM
class LoginVM : NavigationViewModel() {
    val data = ApiAds.LoginData()

    private lateinit var ctx: LoginCtx

    var tempLoginData by mutableStateOf<ApiAds.LoginData?>(null)

    val editorAuth = LoginCtx.EditorAuth(scope, data)
    val editorPass = LoginCtx.EditorPass(scope)

    var loading by mutableStateOf(false)
        private set

    override fun onRelease() {

    }

    interface Action {
        fun login(
            onFail: () -> Unit = {}
        )

        fun changePassword(
            onFail: (Throwable) -> Unit = {}
        )
    }

    val action = object : Action {
        override fun login(onFail: () -> Unit) {
            loading = true
            scope.launch {
                runCatching {
                   Repository.login(
                        editorAuth.login.text.text.trim(),
                        editorAuth.password.text.text.trim()
                    )
                }.onFailure {
                    it.printStackTrace()
                    onFail()
                }.onSuccess { loginData ->
                    if (editorAuth.password.text.text.trim() == "1234") {
                        tempLoginData = loginData
                    } else {
                        Repository.setup(loginData)

                        ctx.nav.navTo_HomeUI(clearTop = true)
                    }
                }
                loading = false
            }
        }

        override fun changePassword(onFail: (Throwable) -> Unit) {
            val loginData = tempLoginData ?: return
            val newPass = editorPass.password.text.text.trim()
            scope.launch {
                runCatching {
                    Repository.changePassword(loginData, newPass)
                    Repository.setup(loginData.copy(pass = newPass))
                }.onFailure {
                    onFail(it)
                }.onSuccess {
                    tempLoginData = null
                    editorPass.password.set(androidx.compose.ui.text.input.TextFieldValue(""))
                    editorPass.passwordRepeat.set(androidx.compose.ui.text.input.TextFieldValue(""))
                    ctx.nav.navTo_HomeUI(clearTop = true)
                }
            }
        }

    }

    fun setup(ctx: LoginCtx) {
        this.ctx = ctx
    }

}